import { STATUS_TYPE } from '../../../enum';
import { BundleCategory } from '../../bundleCategory/api/interface';
import { BundleSubcategory } from '../../bundleSubcategory/api/interface';

export type BundleComponentType = 'addon' | 'cake';

export interface BundleProductComponent {
  id?: string;
  componentType: BundleComponentType;
  productId: string;
  labelEn?: string;
  labelAr?: string;
  qty: number;
  unitPrice: number;
  position?: number;
}

export interface BundleProductVariantOption {
  id?: string;
  productId?: string;
  labelEn: string;
  labelAr?: string;
  previewUrl?: string;
  qty: number;
  price: number;
  position?: number;
}

export interface BundleProductVariantGroup {
  id?: string;
  labelEn: string;
  labelAr?: string;
  isRequired: boolean;
  selectionType: 'single' | 'multiple';
  maxSelections?: number;
  activeState: boolean;
  position?: number;
  options?: BundleProductVariantOption[];
}

export interface BundleProductImage {
  id?: string;
  imageUrl: string;
  position?: number;
}

export interface GetBundleProduct {
  id: string;
}

export interface FindBundleProduct {
  bundleCategoryId?: string;
  bundleSubcategoryId?: string;
  search?: string;
  activeState?: boolean;
  limit?: number;
  skip?: number;
}

export interface CreatePatchBundleProduct {
  id?: string;
  labelEn: string;
  labelAr: string;
  descriptionEn?: string;
  descriptionAr?: string;
  bundleCategoryId: string;
  bundleSubcategoryId: string;
  position: string | number;
  price: string | number;
  discountedPrice?: string | number;
  previewUrl?: string;
  activeState: boolean;
  showOnHomePage?: boolean;
  overridePrice?: string | number | null;
  componentsActiveState?: boolean;
  variantsActiveState?: boolean;
  effortScore?: string | number;
  images?: Array<string | BundleProductImage>;
  components?: BundleProductComponent[];
  variantGroups?: BundleProductVariantGroup[];
}

export interface BundleProduct {
  id: string;
  labelEn: string;
  labelAr: string;
  price: string;
  discountedPrice: string;
  previewUrl: string;
  descriptionEn: string;
  descriptionAr: string;
  bundleCategoryId: string;
  bundleSubcategoryId: string;
  bundle_category?: BundleCategory;
  bundle_subcategory?: BundleSubcategory;
  position: string | number;
  activeState: boolean;
  showOnHomePage: boolean;
  overridePrice?: string | number | null;
  componentsActiveState?: boolean;
  variantsActiveState?: boolean;
  effortScore?: string | number;
  itemsCount?: number;
  images?: BundleProductImage[];
  components?: BundleProductComponent[];
  variantGroups?: BundleProductVariantGroup[];
  variantGroupsCount?: number;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: BundleProduct[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
